// @flow
import fp from "lodash/fp"

import type { PriorityBoardingOrdered } from "booking/services/additionalServices/services/priorityBoarding/services/types"

/**
 * Check if all passengers (by numOfPassengers)
 * has ordered priority boarding for later specified flight (flightId)
 */
export const allPassengersForFlight = (
  priorityBoardingOrdered: PriorityBoardingOrdered,
  numOfPassengers: number,
) => (flightId: string): boolean =>
  fp.every(
    passengerIndex =>
      fp.compose(
        Boolean,
        fp.getOr(false, [flightId, passengerIndex]),
      )(priorityBoardingOrdered),
    fp.range(0, numOfPassengers),
  )
